import React from "react";
import type { FileRecord } from "../../services/filesService";
import { FileCard } from "./FileCard";

interface Props {
  files: FileRecord[];
  /** Forwarded to each card for its authenticated thumbnail fetch. */
  accessToken?: string;
  onOpen: (id: string) => void;
  onRename: (id: string, title: string) => void | Promise<void>;
  onDuplicate: (id: string) => void | Promise<void>;
  onDeleteRequest: (file: FileRecord) => void;
}

export const FileGrid: React.FC<Props> = ({
  files,
  accessToken,
  onOpen,
  onRename,
  onDuplicate,
  onDeleteRequest,
}) => {
  return (
    <div
      data-testid="my-files-grid"
      style={{
        display: "grid",
        // `1fr` as the max, not a fixed 280px: capping the track left a dead
        // gutter on the right of wide screens. Tracks share the row evenly, so
        // cards stay equal-sized and grow to use the width instead. `auto-fill`
        // still decides the column count from the 220px min, which both bounds
        // that growth (a track can never reach 2x the min) and keeps empty
        // tracks so a shrinking search result set doesn't slide cards sideways.
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: "1.25rem",
        padding: "1.5rem 2rem 2rem",
      }}
    >
      {files.map((file) => (
        <FileCard
          key={file.id}
          file={file}
          accessToken={accessToken}
          onOpen={onOpen}
          onRename={onRename}
          onDuplicate={onDuplicate}
          onDeleteRequest={onDeleteRequest}
        />
      ))}
    </div>
  );
};

export default FileGrid;
